export default __webpack_public_path__ + "static/media/Levitate D6.1 Defining the future of passenger car transport.6bff6403.pdf";